export default "__VITE_ASSET__Cgh2teeN__ 778w";